const ConfigurableQuickBuy = class extends HTMLElement {
    selectedEls = this.querySelector('.quick-buy__selected-elements');
    dropdownVariants = this.querySelector('.quick-buy__dropdown-variants');
    swatchSelector = this.querySelectorAll('.quick-buy__type-box .quick-buy__swatch, .quick-buy__swatch[data-product-url]');
    productId = this.querySelector('input[data-name="product-id"]');
    productCard = this.closest('.product-card');

    // Collection page Sizes
    dropdownSizes = this.querySelector('.quick-buy__dropdown-sizes');
    sizesTrigger = this.querySelector('.quick-buy__sizes-trigger');
    sizes = this.dropdownSizes?.querySelectorAll('.quick-buy__size');

    connectedCallback () {
        this.selectedEls?.addEventListener('click', this.toggleDropdown.bind(this, this.dropdownVariants));
        this.sizesTrigger?.addEventListener('click', this.toggleDropdown.bind(this, this.dropdownSizes));
        this.swatchSelector.forEach((item) => {
            item.addEventListener('click', this.changeSelectedOption.bind(this))
        });
        this.sizes?.forEach(size => {
            size.addEventListener('click', this.changeSelectedVariant.bind(this))
        })
        if (this.productCard) {
            this.productCard.addEventListener('mouseleave', () => {
                // close any open dropdowns
                const openedEl = this.querySelector('.quick-buy__dropdown.open');
                const openedTrigger = this.querySelector('.dropdown_tigger.open');

                if (openedEl) {
                    openedEl.classList.remove('open');
                }
                if (openedTrigger) {
                    openedTrigger.classList.remove('open');
                }
                if (openedEl || openedTrigger) {
                    this.closest('.product-card').classList.remove('open');
                }
            })
        }
    }

    toggleDropdown (el, e) {
        const clickedEl = e.currentTarget;

        // RESET in case they are already open
        const openedEl = this.querySelector('.quick-buy__dropdown.open');
        const openedTrigger = this.querySelector('.dropdown_tigger.open');
        if (openedEl != null) {
            openedEl.classList.remove('open')
            openedTrigger.classList.remove('open');
            this.closest('.product-card').classList.remove('open');
        }

        // Open if the element clicked is not the one already open
        if (openedTrigger !== clickedEl) {
            el.classList.toggle('open');
            clickedEl.classList.toggle('open');
            this.closest('.product-card').classList.toggle('open');
        }
    }

    changeSelectedOption (e) {
        const newOption = e.currentTarget;
        const type = newOption.dataset.type;
        const model = newOption.dataset.model;
        const productUrl = newOption.dataset.productUrl;
        const accordion = this.closest('.accordion');

        if (productUrl) {
            e.preventDefault();

            /* Quick-buy modal context: the modal is appended to <body> by
               the theme, so it's not inside .product-card. We detect it by
               checking for a <quick-buy-modal> ancestor. */
            const quickBuyModal = this.closest('quick-buy-modal');
            if (quickBuyModal) {
                this.swapQuickBuyModal(quickBuyModal, productUrl);
                return;
            }

            /* Main product page context (no .product-card, no modal): swap
               the whole product section in place via WBProductSwap. */
            if (!this.productCard && window.WBProductSwap) {
                window.WBProductSwap.swapToProduct(productUrl);
                return;
            }
        }


        if (accordion) {
            const selectedElAccordion = accordion.querySelector('div[data-field="selected-value"]');
            if (selectedElAccordion) {
                selectedElAccordion.style.backgroundImage = `url(${newOption.dataset.img})`;
                selectedElAccordion.dataset.img = `${newOption.dataset.img}`;

                if (this.productId) {  // ← Add null check
                    this.productId.value = `${newOption.dataset.model}`;
                } else {
                    const productId = this.querySelector('input[data-name="product-id"]');
                    this.productId.value = `${newOption.dataset.model}`;
                }
            }
        } else {
            if (type) {
                const elToChange = this.selectedEls.querySelector(`.quick-buy__selected-value[data-type="${type}"]`);
                if (elToChange) {
                    const options = this.querySelectorAll(`.quick-buy__swatch[data-type="${type}"]`);
                    options.forEach((option) => {
                        option.classList.remove('checked');
                    })
                    newOption.classList.add('checked');
                    elToChange.style.backgroundImage = `url(${newOption.dataset.img})`;
                    elToChange.dataset.img = `${newOption.dataset.img}`;
                    if (this.productId) {  // ← Add null check
                        this.productId.value = `${newOption.dataset.model}`;
                    } else {
                        const productId = this.querySelector('input[data-name="product-id"]');
                        this.productId.value = `${newOption.dataset.model}`;
                    }
                }
            }

            // HIDE OTHER PRODUCT SIZES
            if (model) {
                this.sizes.forEach(sizeEl => {
                    if (sizeEl.dataset.model === model) {
                        sizeEl.classList.remove('hidden');
                    } else {
                        sizeEl.classList.add('hidden');
                    }
                });
            }
        }
    }

    async swapQuickBuyModal (modal, productUrl) {
        try {
            modal.setAttribute('aria-busy', 'true');
            const response = await fetch(productUrl);
            const html = await response.text();
            const tempDoc = new DOMParser().parseFromString(html, 'text/html');
            const quickBuyContent = tempDoc.getElementById('quick-buy-content');
            if (quickBuyContent) {
                /* Save the original product URL so we can reset on modal close */
                if (!modal.dataset.originalProductUrl) {
                    modal.dataset.originalProductUrl = modal.getAttribute('product-url');
                }

                modal.replaceChildren(quickBuyContent.content.cloneNode(true).firstElementChild);
                modal.setAttribute('product-url', productUrl);

                /* Reset to original product when the modal closes */
                if (!modal.__resetListenerAttached) {
                    modal.addEventListener('dialog:after-hide', function () {
                        const originalUrl = modal.dataset.originalProductUrl;
                        if (originalUrl) {
                            modal.setAttribute('product-url', originalUrl);
                            delete modal.dataset.originalProductUrl;
                        }
                    });
                    modal.__resetListenerAttached = true;
                }
            }
        } catch (err) {
            console.error('[configurable-quick-buy] quick-buy modal swap failed', err);
        } finally {
            modal.setAttribute('aria-busy', 'false');
        }
    }

    changeSelectedVariant (e) {
        const target = e.currentTarget;
        // target = button submit
        e.preventDefault();
        const variantID = target.dataset.id;
        this.productId = variantID;
        this.handleAddToCart(target, variantID);
    }

    async handleAddToCart (target, variantID) {
        const cartDrawer = document.querySelector('#cart-drawer');
        const form = this.querySelector('.shopify-product-form');
        form.querySelector('input[name="id"]').value = variantID;

        const formData = {};
        const elements = form.querySelectorAll('input, select, textarea');
        elements.forEach(el => {
            if (el.name && el.value !== undefined) {
                if (el.type === 'checkbox') {
                    formData[el.name] = el.checked;
                } else {
                    formData[el.name] = el.value;
                }
            }
        });

        try {
            // Wait for addToCart to finish (it will throw on error thanks to updateCart)
            await addToCart(formData, true, false, true);

            // Only on success do we close the dropdown and show the drawer
            this.toggleDropdown(this.dropdownSizes, { currentTarget: this.sizesTrigger });
            cartDrawer.show();
        } catch (error) {
            alert(error.message);
            // Error handling is already done in updateCart, so we can just return here
            return;
        }
    }


};

window.customElements.define('configurable-quick-buy', ConfigurableQuickBuy);
